<template>
  <div>
    <div v-if="!isTablet">
      <div class="bank-logo d-flex justify-content-between">
        <b-img
          @click="changeBank('krungsri')"
          src="/images/logo-Krungsri.png"
          class="logo-item"
          v-bind:class="{'active': selectedBank == 'krungsri'}" 
          :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
        ></b-img>
        <b-img
          @click="changeBank('bangkokBank')"
          src="/images/logo-Bangkok-Bank.png"
          class="logo-item"
          v-bind:class="{'active': selectedBank == 'bangkokBank'}" 
          :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
        ></b-img>
        <b-img
          @click="changeBank('krungthai')"
          src="/images/logo-KTB.png"
          class="logo-item"
          v-bind:class="{'active': selectedBank == 'krungthai'}" 
          :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
        ></b-img>
        <b-img
          @click="changeBank('scb')"
          src="/images/logo-SCB.png"
          class="logo-item"
          v-bind:class="{'active': selectedBank == 'scb'}" 
          :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
        ></b-img>
      </div>
      <div class="wrap-btn-payment">
        <b-spinner v-if="loading" label="Loading..." variant="success"></b-spinner>
        <b-button v-else class="btn-payment" id="processPayment" @click="processPayment">{{ formattedAmount }}</b-button>
        <br />
        <b-img src="/images/secured.png"  
        :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
      </div>
    </div>
    <div v-if="isTablet">
      <b-container fluid="xl">
        <b-row>
          <b-col cols="12">
            <div class="wrap-online-bank">
              <div
                class="item"
                @click="changeBank('krungsri')"
                v-bind:class="{'active': selectedBank == 'krungsri'}"
              >
                <b-img src="/images/logo-Krungsri.png" class="logo-item"
                :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                <div class="text">{{$t('payment.Bank of Ayudhya')}}</div>
                <div v-if="selectedBank == 'krungsri'" class="active-circle"></div>
              </div>
              <div
                class="item"
                @click="changeBank('bangkokBank')"
                v-bind:class="{'active': selectedBank == 'bangkokBank'}"
              >
                <b-img src="/images/logo-Bangkok-Bank.png" class="logo-item"
                :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                <div class="text">{{$t('payment.Bangkok Bank')}}</div>
                <div v-if="selectedBank == 'bangkokBank'" class="active-circle"></div>
              </div>
              <div
                class="item"
                @click="changeBank('krungthai')"
                v-bind:class="{'active': selectedBank == 'krungthai'}"
              >
                <b-img src="/images/logo-KTB.png" class="logo-item"
                :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                <div class="text">{{$t('payment.Krung Thai Bank')}}</div>
                <div v-if="selectedBank == 'krungthai'" class="active-circle"></div>
              </div>
              <div
                class="item"
                @click="changeBank('scb')"
                v-bind:class="{'active': selectedBank == 'scb'}"
              >
                <b-img src="/images/logo-SCB.png" class="logo-item"
                :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                <div class="text">{{$t('payment.Krung Thai Bank')}}</div>
                <div v-if="selectedBank == 'scb'" class="active-circle"></div>
              </div>
            </div>
          </b-col>
          <b-col col="12">
            <div class="wrap-btn-payment-mobile">
              <b-spinner v-if="loading" label="Loading..." variant="success"></b-spinner>
              <b-button v-else class="btn-payment" id="processPayment" @click="processPayment()">{{ formattedAmount }}</b-button>
              <br />
              <b-img src="/images/secured.png" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";

export default {
  name: "onlineBanking",
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedBank: "",
      loading: false
    };
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  computed: {
    ...mapGetters("UserController", ["isTablet"])
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    processPayment() {
      this.loading = true;
      var vm = this;
      if(vm.selectedBank === "") return;
      vm.PAY({
        bank: vm.selectedBank,
        user_payment_id: vm.orderId,
        previous_payment_id: vm.previousPendingPaymentId
      })
        .then(function(response) {
          var bankUrl = response.data.data.redirect_uri;
          window.location.href = bankUrl;
        })
        .catch(function(error) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: { id: vm.orderId, previousPendingPaymentId: vm.previousPendingPaymentId }
          });
        });
    },
    changeBank(bank) {
      this.selectedBank = bank;
    }
  },
  mounted() {
    $(function() {});
  }
};
</script>